<div class="flex">
  <span class="flex items-center justify-center h-10 min-w-[108px] rounded-md border border-ui-gray-light bg-ui-gray-900 text-ui-dark text-xl font-semibold mr-5 mt-[26px]">
    IF
  </span>
  <div class="w-full">
    <label
      class="input-main-label block mt-0 mb-1"
      for="dataPoint"
    >
      Data Point*
    </label>

    <mat-form-field
      class="select-classic has-validation w-full"
      appearance="outline"
    >
      <mat-select
        id="dataPoint"
        (blur)="onTouched()"
        (ngModelChange)="onValueChange($event)"
        [disabled]="isDisabled()"
        [errorStateMatcher]="errorMatcher"
        [ngModel]="value()"
        panelClass="single-select-overlay"
        placeholder="Select data point"
      >
        @for (attribute of realtimeAttributes() || [] | sort : 'asc' : 'name'; track attribute.name) {
          <mat-option [value]="attribute.name">
            {{ attribute.name }}
          </mat-option>
        }
      </mat-select>

      <mat-icon
        class="arrow-down"
        fontIcon="keyboard_arrow_down"
        matSuffix
      />

      @if (ngControl.invalid && (ngControl.touched || ngControl.dirty)) {
        <mat-error>Input is not valid</mat-error>
      }
    </mat-form-field>
  </div>
</div>
